var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.735,
    height: 77.729,
    viewBox: "0 0 59.735 77.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e76f51;}.b{fill:#ff8a6c;}.c{fill:#ffd2c6;}.d{fill:#eaeae8;}.e{fill:#cbcbcb;}.f{fill:#0bafea;}.g{fill:#ffb63b;}.h{fill:#02a437;}.i{fill:#3b3735;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M179.943,94.123H128V24l51.943.186Z",
    transform: "translate(-33.507 -6.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M176.047,114.228H128V48h35.062l12.986,12.986Z",
    transform: "translate(-33.507 -26.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M147.943,125.938H96V56h38.957l12.986,12.986Z",
    transform: "translate(-6.701 -33.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M195.27,171.687H168v-5.194l3.9-1.3,2.6-5.194h12.986l2.6,5.194,5.194,1.3Z",
    transform: "translate(-67.014 -120.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M210.18,165.194H192L194.6,160h12.986Z",
    transform: "translate(-87.118 -120.626)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 3.5,
    cy: 3,
    rx: 3.5,
    ry: 3,
    transform: "translate(103.867 48.436)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 2.5,
    cy: 3,
    rx: 2.5,
    ry: 3,
    transform: "translate(118.867 48.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M194.6,221.194a2.6,2.6,0,1,1,2.6-2.6A2.6,2.6,0,0,1,194.6,221.194Zm0-3.9a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,194.6,217.3Z",
    transform: "translate(-87.118 -167.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M282.6,221.194a2.6,2.6,0,1,1,2.6-2.6A2.6,2.6,0,0,1,282.6,221.194Zm0-3.9a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,282.6,217.3Z",
    transform: "translate(-160.834 -167.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M240,160h2.6v6.493H240Z",
    transform: "translate(-127.327 -120.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M348.986,68.986H336V56Z",
    transform: "translate(-207.744 -33.507)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.09 58.853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M164.777,282.6H145.3a1.3,1.3,0,1,1,0-2.6h19.479a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-144 -280)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M165.194,322.6h-3.9a1.3,1.3,0,0,1,0-2.6h3.9a1.3,1.3,0,0,1,0,2.6Z",
    transform: "translate(-157.403 -313.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M218.6,322.6h-1.3a1.3,1.3,0,1,1,0-2.6h1.3a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-204.313 -313.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M268.986,322.6H257.3a1.3,1.3,0,1,1,0-2.6h11.687a1.3,1.3,0,0,1,0,2.6Z",
    transform: "translate(-237.82 -313.507)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(106.867 72.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M235.894,370.388a1.3,1.3,0,0,1-.919-.38l-2.6-2.6a1.3,1.3,0,0,1,1.837-1.837l1.8,1.8,9.488-7.116a1.3,1.3,0,1,1,1.558,2.078l-10.389,7.791A1.3,1.3,0,0,1,235.894,370.388Z",
    transform: "translate(-120.624 -288.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M306.389,282.6H297.3a1.3,1.3,0,1,1,0-2.6h9.09a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-174.237 -221.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M341.194,402.6h-3.9a1.3,1.3,0,0,1,0-2.6h3.9a1.3,1.3,0,0,1,0,2.6Z",
    transform: "translate(-207.744 -321.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M343.791,434.6H337.3a1.3,1.3,0,1,1,0-2.6h6.493a1.3,1.3,0,0,1,0,2.6Z",
    transform: "translate(-207.744 -348.474)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88 16)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M146.441,16.186,94.5,16h0a1.3,1.3,0,0,0-1.3,1.3v3.9H89.3a1.3,1.3,0,0,0-1.3,1.3V92.431a1.3,1.3,0,0,0,1.3,1.3h51.943a1.3,1.3,0,0,0,1.3-1.3V88.72h3.9a1.3,1.3,0,0,0,1.3-1.3V17.484A1.3,1.3,0,0,0,146.441,16.186Zm-6.5,74.946H90.6V23.791h36.36V35.479a1.3,1.3,0,0,0,1.3,1.3h11.687Zm-10.389-65.5,8.552,8.552h-8.552Zm15.583,60.5h-2.6V35.479a1.3,1.3,0,0,0-.38-.918L129.174,21.575a1.3,1.3,0,0,0-.918-.38H95.791V18.6l49.346.176Z",
    transform: "translate(-88 -16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M161.3,166.284h2.821a3.9,3.9,0,0,0,7.345,0h6.94a3.9,3.9,0,0,0,7.345,0h2.821a1.3,1.3,0,0,0,1.3-1.3v-5.194a1.3,1.3,0,0,0-.984-1.26l-4.615-1.154-2.33-4.66a1.3,1.3,0,0,0-1.161-.718H167.791a1.3,1.3,0,0,0-1.161.718l-2.357,4.713-3.386,1.128a1.3,1.3,0,0,0-.888,1.232v5.194A1.3,1.3,0,0,0,161.3,166.284Zm6.493,0a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,167.791,166.284Zm14.284,0a1.3,1.3,0,1,1,1.3-1.3A1.3,1.3,0,0,1,182.076,166.284Zm-.8-9.09h-5.69v-2.6h4.392Zm-12.679-2.6h4.392v2.6H167.3Zm-6,6.13,2.808-.936h17.81l4.055,1.014v2.882h-1.522a3.9,3.9,0,0,0-7.345,0h-6.94a3.9,3.9,0,0,0-7.345,0H162.6Z",
    transform: "translate(-148.313 -129.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M166.076,281.3a1.3,1.3,0,0,0-1.3-1.3H145.3a1.3,1.3,0,1,0,0,2.6h19.479A1.3,1.3,0,0,0,166.076,281.3Z",
    transform: "translate(-134.91 -237.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M165.194,320h-3.9a1.3,1.3,0,0,0,0,2.6h3.9a1.3,1.3,0,0,0,0-2.6Z",
    transform: "translate(-148.313 -270.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M217.3,320a1.3,1.3,0,1,0,0,2.6h1.3a1.3,1.3,0,1,0,0-2.6Z",
    transform: "translate(-195.223 -270.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M270.284,321.3a1.3,1.3,0,0,0-1.3-1.3H257.3a1.3,1.3,0,1,0,0,2.6h11.687A1.3,1.3,0,0,0,270.284,321.3Z",
    transform: "translate(-228.73 -270.654)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M218.946,353.691l-2.5,1.876a9.066,9.066,0,1,0,1.32,2.256l2.74-2.054a1.3,1.3,0,0,0-1.558-2.078Zm-3.117,7.532a6.5,6.5,0,1,1-1.461-4.1l-4.91,3.682-1.8-1.8a1.3,1.3,0,0,0-1.837,1.837l2.6,2.6a1.3,1.3,0,0,0,1.7.121l5.468-4.1a6.475,6.475,0,0,1,.245,1.764Z",
    transform: "translate(-182.067 -297.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M296,281.3a1.3,1.3,0,0,0,1.3,1.3h9.09a1.3,1.3,0,1,0,0-2.6H297.3A1.3,1.3,0,0,0,296,281.3Z",
    transform: "translate(-262.237 -237.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M337.3,400a1.3,1.3,0,0,0,0,2.6h3.9a1.3,1.3,0,0,0,0-2.6Z",
    transform: "translate(-295.744 -337.668)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M343.791,432H337.3a1.3,1.3,0,1,0,0,2.6h6.493a1.3,1.3,0,0,0,0-2.6Z",
    transform: "translate(-295.744 -364.474)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermit);
export default __webpack_public_path__ + "static/media/permit.cc6c7fcf0c3e0e0a4385668460a03694.svg";
export { ForwardRef as ReactComponent };